export const headerBonDataImportDetail = [
  {
    headerClassName: 'px-4 py-5',
    headerName: 'rowIndex',
    key: 'rowIndex',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'status',
    key: 'status',
  },
  // {
  //   headerClassName: 'px-4 py-5',
  //   headerName: 'errorMessage',
  //   key: 'errorMessage',
  // },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'agencyCommission',
    key: 'agencyCommission',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'agencyCommissionPercent',
    key: 'agencyCommissionPercent',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'agencyKey',
    key: 'agencyKey',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'agencyName',
    key: 'agencyName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'agentName',
    key: 'agentName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondAmount',
    key: 'bondAmount',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondAmountChangesPositiveAndNegative',
    key: 'bondAmountChangesPositiveAndNegative',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondDefinitionState',
    key: 'bondDefinitionState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondDescription',
    key: 'bondDescription',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondReferenceNumber',
    key: 'bondReferenceNumber',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'bondRiskState',
    key: 'bondRiskState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'cancelOrCloseDate',
    key: 'cancelOrCloseDate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'cancelOrCloseReason',
    key: 'cancelOrCloseReason',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'cancellableIndicator',
    key: 'cancellableIndicator',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierBondNumber',
    key: 'carrierBondNumber',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierBranch',
    key: 'carrierBranch',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierCommissionPercent',
    key: 'carrierCommissionPercent',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierKey',
    key: 'carrierKey',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierName',
    key: 'carrierName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierTransactionCommissionAmount',
    key: 'carrierTransactionCommissionAmount',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'carrierUnderwriter',
    key: 'carrierUnderwriter',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'classCode',
    key: 'classCode',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'completedApprovalSaleDate',
    key: 'completedApprovalSaleDate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'dateChangedFlagTransaction',
    key: 'dateChangedFlagTransaction',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'disbursementDate',
    key: 'disbursementDate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'effectiveDate',
    key: 'effectiveDate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'expiryDate',
    key: 'expiryDate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'noticeInDays',
    key: 'noticeInDays',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeAddressLine1',
    key: 'obligeeAddressLine1',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeAddressLine2',
    key: 'obligeeAddressLine2',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeCity',
    key: 'obligeeCity',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeKey',
    key: 'obligeeKey',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeName',
    key: 'obligeeName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeState',
    key: 'obligeeState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'obligeeZipcode',
    key: 'obligeeZipcode',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'premiumCalculationDescription',
    key: 'premiumCalculationDescription',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountAddressLine1',
    key: 'principalAccountAddressLine1',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountAddressLine2',
    key: 'principalAccountAddressLine2',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountCity',
    key: 'principalAccountCity',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountName',
    key: 'principalAccountName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountState',
    key: 'principalAccountState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAccountZipcode',
    key: 'principalAccountZipcode',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAddressLine1',
    key: 'principalAddressLine1',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalAddressLine2',
    key: 'principalAddressLine2',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalCity',
    key: 'principalCity',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalKey',
    key: 'principalKey',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalName',
    key: 'principalName',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalState',
    key: 'principalState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'principalZipcode',
    key: 'principalZipcode',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'probateCourtState',
    key: 'probateCourtState',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'probateTypeOfBond',
    key: 'probateTypeOfBond',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'rate',
    key: 'rate',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'renewalAction',
    key: 'renewalAction',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'transactionComment',
    key: 'transactionComment',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'transactionPremium',
    key: 'transactionPremium',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'transactionStatus',
    key: 'transactionStatus',
  },
  {
    headerClassName: 'px-4 py-5',
    headerName: 'transactionType',
    key: 'transactionType',
  },
]
